import React, { Component } from "react";
export default class Footer extends Component {
  render() {
    return (
      <div className="container  text-white p-0 d-print-none ">
        <div className="card bg-primary p-2 pt-4 border-0">
          <div className="row mb-4 ">
            <div className="col-md-6 col-sm-11 col-xs-11">
              <div className="footer-text pull-left">
                <div className="d-flex align-items-center">
                  <h4 className="font-weight-bold bg-secondary p-1 rounded-1 text-white ">
                    {" "}
                    IDEAL{" "}
                  </h4>
                  <h4 className=" px-1">TRAINING ACADEMY</h4>
                </div>
                <p className="card-text">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Commodi non pariatur numquam animi nam at impedit odit nisi.
                </p>
                <div className="social mt-2 mb-3 ">
                  {" "}
                  <i className="fa fa-facebook-official fa-lg"></i>{" "}
                  <i className="fa fa-instagram fa-lg"></i>{" "}
                  <i className="fa fa-twitter fa-lg"></i>{" "}
                  <i className="fa fa-linkedin-square fa-lg"></i>{" "}
                  <i className="fa fa-facebook"></i>{" "}
                </div>
              </div>
            </div>

            <div className="col-md-2 col-sm-4 col-xs-4">
              <h5 className="heading">Services</h5>
              <ul className="list-unstyled">
                <li>IT Consulting -</li>
                <li>Development</li>
                <li>Cloud</li>
                <li>DevOps & Support</li>
              </ul>
            </div>
            <div className="col-md-2 col-sm-4 col-xs-4">
              <h5 className="heading">Industries</h5>
              <ul className="list-unstyled">
                <li>Finance</li>
                <li>Public Sector</li>
                <li>Smart Office</li>
                <li>Retail</li>
              </ul>
            </div>
            <div className="col-md-2 col-sm-4 col-xs-4">
              <h5 className="heading">Company</h5>
              <ul className="list-unstyled">
                <li>
                  <a
                    href="./AboutUs"
                    className="text-white text-decoration-none"
                  >
                    {" "}
                    About US
                  </a>
                </li>
                <li>Blog</li>
                <li>
                  <a
                    href="./ContactUs"
                    className="text-white text-decoration-none"
                  >
                    {" "}
                    Contact US
                  </a>
                </li>
                <li>Join Us</li>
              </ul>
            </div>
          </div>
          <div className="divider mb-4 bg-light pt-1"> </div>
          <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-6">
              <div className="pull-left">
                <p>
                  <i className="fa fa-copyright"></i> 2022{" "}
                  <strong>IDEAL TRAINING ACADEMY</strong>
                </p>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-6">
              <div className="pull-right mr-4 d-flex policy justify-content-between">
                <div>Terms of Use |</div>
                <div>Privacy Policy |</div>
                <div>Cookie Policy</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
